export default {
  scheme:{
    message:{
      e_new: "Ошибка создания новой схемы.  {{detail}}",
    },
    countUsed: "Общее количество связей с элементами справочника",
    inScheme: "Связанные концепты"
  },
  concept: {
    new: {
      title: "Новый концепт",
      cancelText: "Отменить",
      okText: "Создать",
      },
    message: {
      ok_link: "Концепт добавлен.",
      ok_new:  "Создан новый концепт",
      ok_unlink: "Запись удалена.",
      e_detail: "Ошибка при получении дополнительной информации о концепте. {{detail}}",
      e_new: "Ошибка создания концепта.  {{detail}}",
    }
  }
}
